import i18next from "i18next";
import { IActions } from '../../../../../clients/models/commandBar-actions-model';
import { IQuantity } from '../../../../../common/models/quantity.model';
import {Quantity} from "../../../../../common/models/quantity.model"

export const generateOthers = (quantity: IQuantity, actions: IActions) => {
    const t = i18next.getFixedT(null, "admin");
    if (quantity === Quantity.NONE) {
      return [
        {
          key: "add",
          text: t("nav.add"),
          iconProps: { iconName: "add" },
          name: "add",
          onClick: actions.toggle,
        },

      ];
    } else {
      return [
        {
          key: "delete",
          text: t("nav.delete"),
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.deleteDepartmentById,
        },
        {
          key: "edit",
          text: t("nav.edit"),
          iconProps: { iconName: "edit" },
          name: "add",
          onClick: actions.toggle,
        },
      ];
    }
  };